import { atom } from 'jotai'

import { type NotificationItem } from '~/utils'

export const notificationsAtom = atom<NotificationItem[]>([])
